// extracted by mini-css-extract-plugin
export var callCard = "_ml-0";
export var callMessageButton = "_ml-1";
export var helpIcon = "_ml-3";
export var helpIconContainer = "_ml-4";
export var verticalDivider = "_ml-2";